module.exports = __webpack_public_path__ + "static/media/holder.70f86d78.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/Holders Modal/holder.png
// module id = 780
// module chunks = 0